import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { WEEKDAYS_VN, CALENDAR_DOW, MONTHS_VN } from "../XoSoCompound/constants";

dayjs.extend(utc);

export { WEEKDAYS_VN, CALENDAR_DOW, MONTHS_VN };

export const TZ = "Asia/Ho_Chi_Minh";
export const GAME = "SAU_X_BA_SAU";
export const TITLE = "Kết quả xổ số điện toán 6X36";
export const PRODUCT = "6X36";
export const DRAW_TIME = "18:00";
export const FIRST_DRAW = "2011-01-01";
export const HISTORY_DRAWS = 15;
export const DRAW_DOW = [3, 6];

export function drawDateKey(drawDate) {
  if (!drawDate) return null;
  const raw = String(drawDate);
  const d = /^\d{4}-\d{2}-\d{2}$/.test(raw) ? dayjs(raw) : dayjs.utc(raw);
  return d.isValid() ? d.format("YYYY-MM-DD") : null;
}

export function formatBall(n) {
  return String(n ?? "").padStart(2, "0");
}

export function historyDates(anchor, count = HISTORY_DRAWS) {
  const dates = [];
  const seen = new Set();
  const push = (key) => {
    if (!key || seen.has(key)) return;
    seen.add(key);
    dates.push(key);
  };

  push(anchor);
  let d = dayjs(anchor);
  while (dates.length < count) {
    d = d.subtract(1, "day");
    if (DRAW_DOW.includes(d.day())) push(d.format("YYYY-MM-DD"));
  }
  return dates;
}
